import clsx from 'clsx';
import React from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';

const gridAreas = {
  filter: 'filter',
  content: 'content',
};

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'grid',
    height: theme.pxToRem(600),
    width: '100%',
    gridTemplateAreas: `
        '${gridAreas.filter} ${gridAreas.content}'
      `,
    gridTemplateColumns: 'max-content 1fr',
    gridTemplateRows: '100% 1fr',
    background:
      theme.palette.mode === 'dark'
        ? theme.palette.background.paper
        : theme.palette.common.white,
    borderRadius: theme.pxToRem(4),
    boxShadow: theme.boxShadows.table,
    color: theme.palette.text.primary,
  },
  filter: {
    display: 'flex',
    width: theme.pxToRem(288),
    gridArea: gridAreas.filter,
    overflowX: 'hidden',
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  content: {
    gridArea: gridAreas.content,
    overflow: 'auto',
  },
}));

export type FilterContentLayoutManagerClasses = GetClasses<typeof useStyles>;

export interface FilterContentLayoutManagerProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  filter?: React.ReactNode;
}

export const FilterContentLayoutManager: React.FC<
  FilterContentLayoutManagerProps
> = props => {
  const { children, className, filter, ...rootProps } = props;
  const classes = useStyles(props);

  return (
    <div className={clsx(classes.root, className)} {...rootProps}>
      {!!filter && <div className={classes.filter}>{filter}</div>}
      <div className={classes.content}>{children}</div>
    </div>
  );
};

export default FilterContentLayoutManager;
